import {
  AlertCircle,
  Bookmark,
  Briefcase,
  Building,
  Calendar,
  CheckCircle,
  Clock,
  Flag,
  Gift,
  Heart,
  HelpCircle,
  Home,
  Info,
  type LucideIcon,
  Mail,
  MessageCircle,
  MessageSquare,
  Phone,
  Shirt,
  Sparkles,
  Star,
  Tag,
  ThumbsDown,
  ThumbsUp,
  User,
  Users,
  XCircle,
  Zap,
} from "lucide-react";

export type AdditionalFieldIconType =
  | "TAG"
  | "BOOKMARK"
  | "FLAG"
  | "STAR"
  | "HEART"
  | "MESSAGE_CIRCLE"
  | "MESSAGE_SQUARE"
  | "PHONE"
  | "MAIL"
  | "USER"
  | "USERS"
  | "CALENDAR"
  | "CLOCK"
  | "ALERT_CIRCLE"
  | "CHECK_CIRCLE"
  | "X_CIRCLE"
  | "INFO"
  | "HELP_CIRCLE"
  | "BRIEFCASE"
  | "BUILDING"
  | "HOME"
  | "GIFT"
  | "THUMBS_UP"
  | "THUMBS_DOWN"
  | "ZAP"
  | "SPARKLES"
  | "SHIRT";

export const ADDITIONAL_FIELD_ICON_MAP: Record<AdditionalFieldIconType, LucideIcon> = {
  TAG: Tag,
  BOOKMARK: Bookmark,
  FLAG: Flag,
  STAR: Star,
  HEART: Heart,
  MESSAGE_CIRCLE: MessageCircle,
  MESSAGE_SQUARE: MessageSquare,
  PHONE: Phone,
  MAIL: Mail,
  USER: User,
  USERS: Users,
  CALENDAR: Calendar,
  CLOCK: Clock,
  ALERT_CIRCLE: AlertCircle,
  CHECK_CIRCLE: CheckCircle,
  X_CIRCLE: XCircle,
  INFO: Info,
  HELP_CIRCLE: HelpCircle,
  BRIEFCASE: Briefcase,
  BUILDING: Building,
  HOME: Home,
  GIFT: Gift,
  THUMBS_UP: ThumbsUp,
  THUMBS_DOWN: ThumbsDown,
  ZAP: Zap,
  SPARKLES: Sparkles,
  SHIRT: Shirt,
};

/**
 * Get the Lucide icon component for an additional field icon type
 *
 * @param icon - The icon type from the API
 * @returns The Lucide icon component, defaults to Tag if icon is invalid/missing
 */
export function getAdditionalFieldIcon(icon?: AdditionalFieldIconType | null): LucideIcon {
  if (!icon || !(icon in ADDITIONAL_FIELD_ICON_MAP)) {
    return Tag; // Default fallback
  }
  return ADDITIONAL_FIELD_ICON_MAP[icon];
}
